export default [
  {
    path: '/devices',
    name: 'homepage',
    view: 'HomePage'
  },
  {
    path: '/scenarios',
    name: 'scenariospage',
    view: 'ScenariosPage'
  },
  {
    path: '/profile',
    name: 'profilepage',
    view: 'ProfilePage'
  },
  {
    path: '/motions/:id',
    name: 'motionhistory',
    view: 'MotionHistory'
  },
  {
    path: '/heating/:id',
    name: 'heatinghistory',
    view: 'HeatingHistory'
  },
  {
    path: '/lighting/:id',
    name: 'lightinghistory',
    view: 'LightingHistory'
  },
  {
    path: '/devices/chart',
    name: 'chartPage',
    view: 'ChartPage'
  },
  {
    path: '/devices/lighting',
    name: 'illuminancePage',
    view: 'IlluminancePage'
  },
  {
    path: '/notification',
    name: 'notificationList',
    view: 'NotificationList'
  },
];
